import { useEffect, useRef, useState } from 'react'
import Message, { MessageProps } from './Message'

type MessageStreamedProps = Pick<
  MessageProps,
  | 'content'
  | 'createdAtTime'
  | 'isNewThread'
  | 'isSender'
  | 'onAskedForFeedback'
  | 'displayFeedback'
> & {
  onEndStream: () => void
}
const charSteps = 5
const speedInMs = 50 //FIXME it's not speed

export default function MessageStreamed({
  content,
  createdAtTime,
  isNewThread,
  isSender,
  onEndStream,
  onAskedForFeedback,
  displayFeedback,
}: MessageStreamedProps) {
  const displayedText = useStreamedText(content)
  useEffect(() => {
    onEndStream()
  }, [displayedText])
  return (
    <Message
      content={displayedText}
      createdAtTime={createdAtTime}
      isNewThread={isNewThread}
      isSender={isSender}
      onAskedForFeedback={onAskedForFeedback}
      displayFeedback={displayFeedback}
    />
  )
}

function useStreamedText(content: string): string {
  if (!content) return ''
  const [displayedText, setDisplayedText] = useState('')
  const [index, setIndex] = useState(0)
  const r = useRef({ index: 0, content, started: false })
  r.current = { index, content, started: false }

  function next() {
    const currentContent = r.current.content
    const currentIndex = r.current.index
    if (currentIndex < currentContent.length) {
      setDisplayedText(currentContent.slice(0, currentIndex))
      setIndex(currentIndex + charSteps)
      return
    }
    setDisplayedText(r.current.content)
  }

  useEffect(() => {
    if (!r.current.started) {
      r.current.started = true
      setInterval(function () {
        next()
      }, speedInMs)
    }
  }, [])

  return displayedText
}
